import React from 'react';
import styled from 'styled-components';
const StyledDiv = styled.div`
	padding: 15px;
	border: 1px solid rgba(128, 128, 128, 1);
	border-radius: 5px;
	display: grid !important;
	grid-template-columns: repeat(3, 1fr);
	grid-row-gap: 10px;
	align-items: center;
	> div {
		text-align: left;
	}
`;
const FormWrapper = ({ children }: any) => {
	return <StyledDiv>{children}</StyledDiv>;
};
export default FormWrapper;
